// Типы тем оформления
export type ThemeMode = 'light' | 'dark' | 'auto';

export interface Theme {
  mode: ThemeMode;
  name: string;
  icon: string;
}

export const SUPPORTED_THEMES: Theme[] = [
  { mode: 'light', name: 'Light', icon: '☀️' },
  { mode: 'dark', name: 'Dark', icon: '🌙' },
  { mode: 'auto', name: 'Auto', icon: '🖥️' },
];

// Интерфейс контекста темы
export interface ThemeContextType {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
  isDark: boolean;
  isLoading: boolean;
}

// Тип для хука useTheme
export interface UseThemeReturn {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
  currentTheme: Theme | undefined;
  supportedThemes: Theme[];
  isDark: boolean;
  isLoading: boolean;
}
